import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  button: {
    fontWeight: 700,
    textAlign: 'center',
    borderRadius: 10,
    fontSize: theme.fonts.sizes.font14PX,
    '& .MuiIcon-root': {
      width: 'auto',
      height: 'auto',
    },
  },
}));

export const useStylesRegularPrimary = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    marginBottom: 16,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));
